// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"db30aa0b","507":"621119d0","625":"9104e556"}[chunkId] + ".chunk.css";
};